export default __webpack_public_path__ + "static/media/720.bb8d4bb4.png";